import {
  GET_QUALIFICATION,
  UPDATE_EDUCATION_INFO,
  UPDATE_LOCAL_TRAINING_INFO,
  UPDATE_FOREIGN_TRAINING_INFO,
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  UPDATE_PUBLICATION_INFO,
  UPDATE_HONOUR_INFO,
  UPDATE_REWARD_INFO,
  DELETE_EDUCATION_INFO,
  DELETE_LOCAL_TRAINING_INFO,
  DELETE_FOREIGN_TRAINING_INFO,
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  DELETE_PUBLICATION_INFO,
  DELETE_HONOUR_INFO,
  DELETE_REWARD_INFO,
} from "./types";
import {
  QualificationType,
  EducationType,
  LocalTrainingType,
  ForeignTrainingType,
  AdditionalProfessionalQualificationType,
  PublicationType,
  HonourType,
  RewardType,
} from "@type/HRM/qualification";

export const getQualificationRequest = (data: number | null) => {
  return {
    type: GET_QUALIFICATION.GET_QUALIFICATION_REQUEST,
    payload: { data },
  } as const;
};

export const getQualificationSuccess = (data: QualificationType) => {
  return {
    type: GET_QUALIFICATION.GET_QUALIFICATION_SUCCESS,
    payload: { data },
  } as const;
};

export const getQualificationFailed = () => {
  return {
    type: GET_QUALIFICATION.GET_QUALIFICATION_FAILED,
  } as const;
};

export const updateEducationsInfoRequest = (data: EducationType) => {
  return {
    type: UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateEducationsInfoSuccess = (data: EducationType) => {
  return {
    type: UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateEducationsInfoFailed = () => {
  return {
    type: UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_FAILED,
  } as const;
};

export const updateLocalTrainingsInfoRequest = (data: LocalTrainingType) => {
  return {
    type: UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateLocalTrainingsInfoSuccess = (data: LocalTrainingType) => {
  return {
    type: UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateLocalTrainingsInfoFailed = () => {
  return {
    type: UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_FAILED,
  } as const;
};

export const updateForeignTrainingsInfoRequest = (
  data: ForeignTrainingType
) => {
  return {
    type: UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateForeignTrainingsInfoSuccess = (
  data: ForeignTrainingType
) => {
  return {
    type: UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateForeignTrainingsInfoFailed = () => {
  return {
    type: UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_FAILED,
  } as const;
};

export const updateAdditionalProfessionalQualificationsInfoRequest = (
  data: AdditionalProfessionalQualificationType
) => {
  return {
    type:
      UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateAdditionalProfessionalQualificationsInfoSuccess = (
  data: AdditionalProfessionalQualificationType
) => {
  return {
    type:
      UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateAdditionalProfessionalQualificationsInfoFailed = () => {
  return {
    type:
      UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED,
  } as const;
};

export const updatePublicationsInfoRequest = (data: PublicationType) => {
  return {
    type: UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updatePublicationsInfoSuccess = (data: PublicationType) => {
  return {
    type: UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePublicationsInfoFailed = () => {
  return {
    type: UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_FAILED,
  } as const;
};

export const updateHonoursInfoRequest = (data: HonourType) => {
  return {
    type: UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateHonoursInfoSuccess = (data: HonourType) => {
  return {
    type: UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateHonoursInfoFailed = () => {
  return {
    type: UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_FAILED,
  } as const;
};

export const updateRewardsInfoRequest = (data: RewardType) => {
  return {
    type: UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateRewardsInfoSuccess = (data: RewardType) => {
  return {
    type: UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateRewardsInfoFailed = () => {
  return {
    type: UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_FAILED,
  } as const;
};

export const deleteEducationInfoRequest = (data: {
  employeeID: number | null;
  educationID: number;
}) => {
  return {
    type: DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteEducationInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteEducationInfoFailed = () => {
  return {
    type: DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_FAILED,
  } as const;
};

export const deleteLocalTrainingInfoRequest = (data: {
  employeeID: number | null;
  localTrainingID: number;
}) => {
  return {
    type: DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteLocalTrainingInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteLocalTrainingInfoFailed = () => {
  return {
    type: DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_FAILED,
  } as const;
};

export const deleteForeignTrainingInfoRequest = (data: {
  employeeID: number | null;
  foreignTrainingID: number;
}) => {
  return {
    type: DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteForeignTrainingInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteForeignTrainingInfoFailed = () => {
  return {
    type: DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_FAILED,
  } as const;
};

export const deleteAdditionalProfessionalQualificationInfoRequest = (data: {
  employeeID: number | null;
  additionalProfessionalQualificationID: number;
}) => {
  return {
    type:
      DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteAdditionalProfessionalQualificationInfoSuccess = (data: {
  id: number;
}) => {
  return {
    type:
      DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteAdditionalProfessionalQualificationInfoFailed = () => {
  return {
    type:
      DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED,
  } as const;
};

export const deletePublicationInfoRequest = (data: {
  employeeID: number | null;
  publicationID: number;
}) => {
  return {
    type: DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deletePublicationInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deletePublicationInfoFailed = () => {
  return {
    type: DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_FAILED,
  } as const;
};

export const deleteHonourInfoRequest = (data: {
  employeeID: number | null;
  honourID: number;
}) => {
  return {
    type: DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteHonourInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteHonourInfoFailed = () => {
  return {
    type: DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_FAILED,
  } as const;
};

export const deleteRewardInfoRequest = (data: {
  employeeID: number | null;
  rewardID: number;
}) => {
  return {
    type: DELETE_REWARD_INFO.DELETE_REWARD_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteRewardInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_REWARD_INFO.DELETE_REWARD_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteRewardInfoFailed = () => {
  return {
    type: DELETE_REWARD_INFO.DELETE_REWARD_INFO_FAILED,
  } as const;
};

export type QualificationActions =
  | ReturnType<typeof getQualificationRequest>
  | ReturnType<typeof getQualificationSuccess>
  | ReturnType<typeof getQualificationFailed>
  | ReturnType<typeof updateEducationsInfoRequest>
  | ReturnType<typeof updateEducationsInfoSuccess>
  | ReturnType<typeof updateEducationsInfoFailed>
  | ReturnType<typeof deleteEducationInfoRequest>
  | ReturnType<typeof deleteEducationInfoSuccess>
  | ReturnType<typeof deleteEducationInfoFailed>
  | ReturnType<typeof updateLocalTrainingsInfoRequest>
  | ReturnType<typeof updateLocalTrainingsInfoSuccess>
  | ReturnType<typeof updateLocalTrainingsInfoFailed>
  | ReturnType<typeof deleteLocalTrainingInfoRequest>
  | ReturnType<typeof deleteLocalTrainingInfoSuccess>
  | ReturnType<typeof deleteLocalTrainingInfoFailed>
  | ReturnType<typeof updateForeignTrainingsInfoRequest>
  | ReturnType<typeof updateForeignTrainingsInfoSuccess>
  | ReturnType<typeof updateForeignTrainingsInfoFailed>
  | ReturnType<typeof deleteForeignTrainingInfoRequest>
  | ReturnType<typeof deleteForeignTrainingInfoSuccess>
  | ReturnType<typeof deleteForeignTrainingInfoFailed>
  | ReturnType<typeof updateAdditionalProfessionalQualificationsInfoRequest>
  | ReturnType<typeof updateAdditionalProfessionalQualificationsInfoSuccess>
  | ReturnType<typeof updateAdditionalProfessionalQualificationsInfoFailed>
  | ReturnType<typeof deleteAdditionalProfessionalQualificationInfoRequest>
  | ReturnType<typeof deleteAdditionalProfessionalQualificationInfoSuccess>
  | ReturnType<typeof deleteAdditionalProfessionalQualificationInfoFailed>
  | ReturnType<typeof updatePublicationsInfoRequest>
  | ReturnType<typeof updatePublicationsInfoSuccess>
  | ReturnType<typeof updatePublicationsInfoFailed>
  | ReturnType<typeof deletePublicationInfoRequest>
  | ReturnType<typeof deletePublicationInfoSuccess>
  | ReturnType<typeof deletePublicationInfoFailed>
  | ReturnType<typeof updateHonoursInfoRequest>
  | ReturnType<typeof updateHonoursInfoSuccess>
  | ReturnType<typeof updateHonoursInfoFailed>
  | ReturnType<typeof deleteHonourInfoRequest>
  | ReturnType<typeof deleteHonourInfoSuccess>
  | ReturnType<typeof deleteHonourInfoFailed>
  | ReturnType<typeof updateRewardsInfoRequest>
  | ReturnType<typeof updateRewardsInfoSuccess>
  | ReturnType<typeof updateRewardsInfoFailed>
  | ReturnType<typeof deleteRewardInfoRequest>
  | ReturnType<typeof deleteRewardInfoSuccess>
  | ReturnType<typeof deleteRewardInfoFailed>;
